module.exports = require('./currify');



//////////////////
// WEBPACK FOOTER
// /data/s1059050/dom32291/dom32291/wp-content/themes/bizwest-theme/node_modules/currify/legacy/index.js
// module id = 10
// module chunks = 0